module.exports = __webpack_public_path__ + "static/the-4hour-body-2a71eed00580b51d226bbf8fea3808ab.jpg";